import { render, staticRenderFns } from "./DetailFormatRepeat.vue?vue&type=template&id=858f49f2"
import script from "./DetailFormatRepeat.vue?vue&type=script&lang=js"
export * from "./DetailFormatRepeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports